module.exports = __webpack_public_path__ + "static/team_matteo-3d6cc89f714170cb17d51e1aa4bad0a5.jpg";